var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SkeletonCustom from '../../../../common/skeleton/SkeletonCustom';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: flex-start;\n"], ["\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: flex-start;\n"])));
var ChatBotHistorySkeletonComponent = function ChatBotHistorySkeletonComponent() {
    return (_jsxs(Wrapper, { children: [_jsx(SkeletonCustom, { width: "97%", height: "60px", diameter: "4px !important", logo: true, logoSize: "50px", margin: "0px 0px 10px 0px", marginSm: "0px 0px 10px 0px" }), _jsx(SkeletonCustom, { width: "97%", height: "120px", diameter: "4px !important", logo: true, logoSize: "50px" })] }));
};
export default ChatBotHistorySkeletonComponent;
var templateObject_1;
